var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2538 9.52091V6.11984L20 8.51802V20H5.5V5.5H8.24587V9.52091C8.24587 9.79706 8.46973 10.0209 8.74587 10.0209H16.7538C17.03 10.0209 17.2538 9.79706 17.2538 9.52091ZM9.24587 9.02091V5.5H16.2538V9.02091H9.24587ZM16.7316 4.5C16.8526 4.5 16.9694 4.54384 17.0605 4.62339L20.8289 7.91423C20.9376 8.00918 21 8.14649 21 8.29084V20.5C21 20.7761 20.7761 21 20.5 21H5C4.72386 21 4.5 20.7761 4.5 20.5V5C4.5 4.72386 4.72386 4.5 5 4.5H16.7316Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSave);
export default __webpack_public_path__ + "static/media/action-save.99da724bd500f7b0a5f313905fe27c1b.svg";
export { ForwardRef as ReactComponent };